import { FC } from "react";
import CONSTANTS from "../constants/constants.json";
import "./styles/page.css";

const { BOOKS_DATA } = CONSTANTS;

const BooksPage: FC = () => {
  return (
    <div className="page">
      <h1 className="page-name">{BOOKS_DATA.PAGE_TITLE}</h1>
      <p className="page-bio">{BOOKS_DATA.PAGE_BIO}</p>

      {BOOKS_DATA.CATEGORIES.map((category) => (
        <section key={category.ID} className="home-section">
          <h2 className="home-section-heading">{category.LABEL}</h2>
          <ul className="book-list">
            {category.BOOKS.map((book) => (
              <li key={book.TITLE} className="book-item">
                <div className="book-header">
                  <span className="book-title">{book.TITLE}</span>
                  <span className="book-author">{book.AUTHOR}</span>
                </div>
                {book.NOTE && <p className="book-note">{book.NOTE}</p>}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};

export default BooksPage;
